import React from 'react';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="container contact-container">
        <div className="contact-info-wrapper">
          <span className="section-tag">Get In Touch</span>
          <h2 className="section-title">
            Let's Discuss Your <span className="highlight">Project</span>
          </h2>
          <p className="contact-description">
            Ready to take your business to the next level? Contact Nodex Global LLC today for a free consultation and discover how we can help you grow.
          </p>
          
          <div className="contact-details">
            <div className="contact-item">
              <div className="contact-icon-box"><FaEnvelope /></div>
              <div>
                <h4>Email Us</h4>
                <p><a href="mailto:hello@nodexgloballlc.com">hello@nodexgloballlc.com</a></p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon-box"><FaMapMarkerAlt /></div>
              <div>
                <h4>Our Office</h4>
                <p>
                  Nodex Global LLC
                  <br />
                  32 N Gould St.
                  <br />
                  Sheridan, WY 82801
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
            <h3 className="form-title">Send a Message</h3>
            <div className="form-group">
              <input type="text" placeholder="Your Name" required />
            </div>
            <div className="form-group">
              <input type="email" placeholder="Your Email" required />
            </div>
            <div className="form-group">
              <input type="text" placeholder="Subject" required />
            </div>
            <div className="form-group">
              <textarea placeholder="Your Message" rows="5" required></textarea>
            </div>
            <button type="submit" className="btn btn-primary w-100">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
